import type { ParsedTable, ChartType } from '../types'

// Import all validator functions
import { canRenderLine } from './line'
import { canRenderPie } from './pie'
import { canRenderBarColumn } from './barColumn'
import { canRenderStackedClustered } from './stackedClustered'
import { canRenderScatter } from './scatter'

/**
 * Type definition for a chart validator function
 */
export type ChartValidatorFunction = (table: ParsedTable) => boolean;

/**
 * Registry mapping ChartType identifiers to their corresponding data validation functions
 * These functions check if the content of the parsed table is suitable for the chart type
 */
export const validators: Record<ChartType, ChartValidatorFunction> = {
  table: () => true, // Always possible to render as a table
  pie: canRenderPie,
  bar: canRenderBarColumn, // Bar and column share the same validation
  column: canRenderBarColumn,
  line: canRenderLine,
  stackedBar: canRenderStackedClustered, // All stacked/clustered variants share validation
  clusteredBar: canRenderStackedClustered,
  stackedColumn: canRenderStackedClustered,
  clusteredColumn: canRenderStackedClustered,
  scatter: canRenderScatter,
}
